import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './WishLists.css';
import cx from 'classnames';

// Components
import WishLists from '../../components/WishLists';
import NotFound from '../../routes/notFound/NotFound';
import EditWishListGroup from '../../components/WishLists/EditWishListGroup';

const WishListsContainer = ({ profileId, wishListId }) => {

  return (
    <div className={s.container}>
      {
        wishListId && profileId && <div className={cx(s.mainSection)}>
          <EditWishListGroup profileId={profileId} wishListId={wishListId} />
        </div>
      }
      {
        !wishListId && profileId && <div className={cx(s.mainSection)}>
          <WishLists profileId={profileId} />
        </div>
      }
      {
        !wishListId && !profileId && <div className={cx(s.mainSection)}>
          <NotFound />
        </div>
      }
    </div>
  );
}

WishListsContainer.propTypes = {
  profileId: PropTypes.number,
  wishListId: PropTypes.number
};

export default withStyles(s)(WishListsContainer);
